import { render, staticRenderFns } from "./Stepper.vue?vue&type=template&id=72d63e1c&scoped=true&"
import script from "./Stepper.vue?vue&type=script&lang=ts&"
export * from "./Stepper.vue?vue&type=script&lang=ts&"
import style0 from "./Stepper.vue?vue&type=style&index=0&id=72d63e1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d63e1c",
  null
  
)

export default component.exports